import { RouteProps } from '@core/navigation';

import { AUTH_ROUTES } from './auth/routes/Auth';
import { SURVEY_ROUTES } from './surveys/routes/Surveys/Surveys';

export const APP_ROUTES: Array<RouteProps> = [...AUTH_ROUTES, ...SURVEY_ROUTES];
